import { default as React } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    // Override for local
    '& [class*="BackstageContent-root"]': {
      backgroundColor: theme.palette.background.paper,
    },
    // Apply background to the parent article that contains the TechDocs shadow root
    '& article:has([data-testid="techdocs-native-shadowroot"])': {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));

/**
 * Wrapper for TechDocs pages that ensures the background uses paper color
 * instead of the default devhubBackground color
 *
 * @param children - The children to render
 */
export const TechDocsWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};
